module.exports = __webpack_public_path__ + "static/media/joya.169370f8.jpeg";